import { render, staticRenderFns } from "./roles_permission_form.vue?vue&type=template&id=dad8181a"
import script from "./roles_permission_form.vue?vue&type=script&lang=js"
export * from "./roles_permission_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports